import { FC, Fragment, useEffect, useState } from 'react';
import { Container, CopyIcon, DashboardLayout, SuccessIconLarge, TooltipCustomCenter } from 'Components';
import { useCardType, useLocalization } from 'Hooks';
import { Box, Button, Typography } from '@material-ui/core';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { StaticContext } from 'react-router';
import { fontSizes, gutters } from 'Theme/Variables';
import { routePath } from 'Navigator/routes';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './CardApplicationUpdateSuccess.scss';
import { useDispatch } from 'react-redux';
import { clearApplicationData } from 'Stores/CardApplication';
import plusOrcSvg from 'Assets/Images/cardTypes/plusOrc.svg';
import plusStdSvg from 'Assets/Images/cardTypes/plusStd.svg';
import iconCheckedSvg from 'Assets/Icons/icon-checked.svg';

type CardApplicationUpdateSuccessProps = RouteComponentProps<{}, StaticContext>;

const CardApplicationUpdateSuccess: FC<CardApplicationUpdateSuccessProps> = ({ location: { state } }: any) => {
  const {
    web_application_updated,
    web_application_no,
    web_card_cargo,
    web_application_received,
    web_application_track,
    web_application_sms,
    card_success_center,
    web_application_copy,
    web_university_success_text,
    web_card_application_success_title,
    web_card_application_success_application_number,
    web_card_application_success_desc,
    web_card_application_success_desc2,
    web_pc_istanbulcard_apply_page_success_btn_apply_card,
    web_btn_anasayfa,
  } = useLocalization();
  const { cardPath } = useCardType(state.pc);
  const history = useHistory();
  const dispatch = useDispatch();
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    const handlePopState = () => {
      history.replace(routePath.cardApplication);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [history]);

  useEffect(() => {
    dispatch(clearApplicationData({ withoutCard: false, withoutStep: true }));
  }, []);

  const isPlus = state.pc.startsWith('IKP_');

  if (isPlus) {
    return (
      <DashboardLayout marginTop={0} noContainer>
        <div id="cardApplicationSteps">
          <Container>
            <div className="cardApplicationSteps">
              <div className="cardApplicationSteps__success">
                <div className="cardApplicationSteps__success__card">
                  <div className="cardApplicationSteps__success__card__check">
                    <img src={iconCheckedSvg} alt="success" />
                  </div>
                  <img
                    src={state.pc === 'IKP_ORC' ? plusOrcSvg : plusStdSvg}
                    alt="card"
                  />
                </div>

                <Typography variant="h5" className="cardApplicationSteps__success__title">
                  {web_card_application_success_title}
                </Typography>

                <div className="cardApplicationSteps__success__number">
                  <Typography variant="body1" className="cardApplicationSteps__success__number__title">
                    {web_card_application_success_application_number}
                  </Typography>
                  <Typography
                    variant="h6"
                    className="cardApplicationSteps__success__number__value"
                    style={{ fontWeight: 'bold' }}
                  >
                    {state.id}
                  </Typography>
                </div>
                <Typography variant="body1" className="cardApplicationSteps__success__desc">
                  {web_card_application_success_desc}
                </Typography>
                <Typography variant="body1" className="cardApplicationSteps__success__desc">
                  {web_card_application_success_desc2}
                </Typography>

                <div className="cardApplicationSteps__success__buttons">
                  <Button
                    variant="contained"
                    onClick={() => history.push(routePath.cardApplications)}
                    color="secondary"
                    style={{ width: '550px' }}
                  >
                    {web_pc_istanbulcard_apply_page_success_btn_apply_card}
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => history.push(routePath.home)}
                    color="secondary"
                    style={{ width: '550px' }}
                  >
                    {web_btn_anasayfa}
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </DashboardLayout>
    );
  }
  return (
    <DashboardLayout>
      <Fragment>
        {show && (
          <Box width={'100%'} display="flex" justifyContent="center">
            <TooltipCustomCenter show={show} title={web_application_copy} onClose={() => setShow(false)} />
          </Box>
        )}
        <div id="cardApplicationUpdateSuccess">
          <Typography variant="h3" component="h1" align="center">
            <Box fontWeight={600}>{state.isApplication ? web_application_received : web_application_updated}</Box>
          </Typography>
          <Typography align="center">
            <Box fontSize={fontSizes.regular} mt={gutters.regular}>
              {state.campusId > 0
                ? web_university_success_text
                : state.fromCenter
                ? card_success_center
                : state.isApplication
                ? web_card_cargo
                : web_card_cargo}
            </Box>
          </Typography>
          <div className="cardApplicationUpdateSuccess__card-area">
            <SuccessIconLarge className="cardApplicationUpdateSuccess__card-area__success" />
            <img className="cardApplicationUpdateSuccess__card-area__img" src={cardPath} alt="" />
          </div>
          <Typography align="center">
            <Box display="flex" alignItems="center" fontSize={fontSizes.regular} mt={gutters.regular}>
              {`${web_application_no}: ${state.id}`}

              <CopyToClipboard onCopy={() => setShow(true)} text={`${state.id}`}>
                <CopyIcon className="cardApplicationUpdateSuccess__card-area__copy" />
              </CopyToClipboard>
            </Box>
          </Typography>
          <Box mt={gutters.big} />
          <Button
            onClick={() => history.push(routePath.cardApplications)}
            style={{ width: 280 }}
            variant="contained"
            color="secondary"
          >
            {web_application_track}
          </Button>
        </div>
      </Fragment>
    </DashboardLayout>
  );
};
export default CardApplicationUpdateSuccess;
